import React from 'react';
import Layout from '../../components/Layout';
import NotFound from '../notFound/NotFound';
import fetch from '../../core/fetch';
import Blog from './blog';
import messages from '../../locale/jsonMessages';
import { dynamicBlogValue } from '../../helpers/GetDynamicItemName/dynamicHomeValue';

export default async function action({ store, params, path, intl, locale }) {

    let blogUrl = '', description = "", title;
    blogUrl = params.u1;
    title = intl?.formatMessage(messages.staticTabTitle);
    const query = `
        query getBlogHome ($pageUrl: String!) {
        getBlogHome (pageUrl: $pageUrl) {
            id
            metaTitle
            metaDescription
            pageUrl
            pageTitle
            content
            footerCategory
            isEnable
            createdAt
       dynamicBlogDetails {
        id
        language
        pageTitle
        content
        metaTitle
        metaDescription
      }
        }
        }
    `;

    const paramsValue = {
        pageUrl: blogUrl
    };

    const resp = await fetch('/graphql', {
        method: 'post',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query: query,
            variables: paramsValue
        }),
        credentials: 'include',
    });

    const { data } = await resp.json();

    if (data && data.getBlogHome) {
        const dynamicData = dynamicBlogValue(data.getBlogHome, intl?.locale || locale);
        title = dynamicData.pageTitle;
        description = dynamicData.metaDescription;
        return {
            title,
            description,
            component: <Layout><Blog image={data.getBlogHome.image} data={data.getBlogHome}></Blog></Layout>,
        };
    }
    else {
        title = "Not Found"
        return {
            title,
            component: <Layout><NotFound title={title} /></Layout>,
            status: 404,
        };
    };

};
